<template>
  <div id="section-sidenav">
    <div class="section-sidenav__content">
      <Input
        :value="active.title"
        label="Nome da seção"
        class="section-sidenav__section-title-input"
        @enter="updateTitle({ id: active.id, value: $event })"
        @blur="updateTitle({ id: active.id, value: $event })"
      />

      <div class="section-sidenav__title">
        Blocos da seção
      </div>

      <Content :id="active.id" :currentView="currentView" :panels="panels" />

      <Divider />

      <Collapsible :label="$t('layout')" closedFaIcon="fa-chevron-down" openedFaIcon="fa-chevron-up">
        <Layout :id="active.id" :currentView="currentView" :options="options[currentView]" />
      </Collapsible>

      <Divider />

      <div class="section-sidenav__buttons-container">
        <Button
          icon="far fa-clone"
          label="Duplicar seção"
          @click="duplicate({ id: active.id })"
          class="section-sidenav__action-button"
        />

        <Button
          icon="fas fa-trash"
          label="Deletar seção"
          @click="batchRemove({ id: active.id })"
          class="section-sidenav__action-button"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Mixin from '@/components/sidenav/landing/Mixin.js'
import Content from '@/components/sidenav/landing/section/Content.vue'
import Layout from '@/components/sidenav/landing/section/Layout.vue'
import Collapsible from '@/shared/components/Collapsible'
import Divider from '@/shared/components/Divider'
import Button from '@/shared/components/Button'
import Input from '@/shared/components/Input'

export default {
  name: 'SectionSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.section-side-nav' },
  mixins: [Mixin],
  components: { Content, Layout, Collapsible, Divider, Button, Input },
  computed: {
    ...mapGetters('landing', ['panels']),
  },
  methods: {
    ...mapActions('landing', ['duplicate', 'batchRemove', 'updateTitle']),
  },
}
</script>

<style lang="scss">
.section-sidenav__content {
  margin-top: 16px;
}

.section-sidenav__title {
  line-height: 1.5rem;
  color: $grey;
  font-weight: 700;
  padding-left: 8px;
  padding-top: 8px;
}

.section-sidenav__action-button {
  margin-top: 16px;
}

.section-sidenav__buttons-container {
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 16px;
  margin-bottom: 32px;
}

.section-sidenav__section-title-input {
  padding-left: 8px;
  padding-right: 8px;
}
</style>
